import React from "react";
import PropTypes from "prop-types";
import ActionButton from "./action-button";

const EditAction = ({ ...props }) => {
  return <ActionButton icon="edit" {...props} />;
};

EditAction.propTypes = {
  /**
   * Indica si se muestra el componente
   **/
  show: PropTypes.bool,
  /**
   * Url del icono del menú
   **/
  url: PropTypes.string,
};

export default EditAction;
